{
  "configuration.linksImMenuUnterstuetzungPublic": "Links im Menu Information (GRUDIS Public)",
  "dashboard.rechtehinweis.legalHintMessage": "Die in GRUDIS abrufbaren Grundstück-Informationen sind ohne Gewähr und haben keinerlei Rechtswirkung.",
  "Fremdsystem": "ZPV",
  "KantGid": "BE-GID",
  "KantonalePersonenID": "ZPV-Nr.",
  "layouts.page.title": "GRUDIS",
  "layouts.page.titleNavigation": "GRUDIS Navigation",
  "titel.zentralePerson": "ZPV-Person",
  "zentraleNr": "ZPV-Nummer"
}
